import styled, { CSSObject } from 'styled-components';

const InboxItemStyled = styled.div(({ theme }) => {
  const styleSheet: CSSObject = {
    height: 50,
    position: 'relative',
    cursor: 'pointer',
    background: theme.color.wfWhite,
    display: 'flex',
    alignItems: 'flex-start',
    padding: `${theme.space[2]}`,
    paddingRight: 48,
    boxSizing: 'border-box',
    transition: `background ${theme.transition.duration} ${theme.transition.func}`,
    '&:hover': {
      background: theme.color.wfGrey50,
    },
  };

  return styleSheet;
});

const TypeStyled = styled.div(({ theme }) => {
  return {
    fontWeight: theme.font.weight.xbold,
    fontSize: theme.font.size.small,
    color: theme.color.wfBlack,
  };
});

const TitleWrapperStyled = styled.div(({ theme }) => {
  return {
    lineHeight: theme.font.lineHeight.small,
    alignItems: 'center',
    display: 'flex',
  };
});

const FileNameStyled = styled.div(({ theme }) => {
  return {
    margin: `0 ${theme.space[1]}`,
    fontWeight: theme.font.weight.regular,
    fontSize: theme.font.size.xsmall,
    color: theme.color.wfBlack,
  };
});

const UserNameStyled = styled.div(({ theme }) => {
  return {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: theme.space[1],
    fontWeight: theme.font.weight.regular,
    fontSize: theme.font.size.small,
    color: theme.color.wfGrey800,
  };
});

const ContentWrapperStyled = styled.div(({ theme }) => {
  return {
    marginLeft: theme.space[2],
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };
});

const ContentStyled = styled.div(({ theme }) => {
  return {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: theme.font.weight.regular,
    fontSize: theme.font.size.small,
    color: theme.color.wfGrey500,
  };
});

const DateWrapperStyled = styled.div(({ theme }) => {
  return {
    minWidth: 40,
    position: 'absolute',
    right: `${theme.space[2]}`,
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
  };
});

interface DateStyledProps {
  disabled: boolean;
}

const DateStyled = styled.div<DateStyledProps>(({ theme, disabled }) => {
  const styleSheet = {
    marginBottom: theme.space[1],
    fontWeight: theme.font.weight.regular,
    fontSize: theme.font.size.xsmall,
    color: theme.color.wfBlack,
  };

  if (disabled) {
    styleSheet.color = theme.color.wfGrey500;
  }

  return styleSheet;
});

const BorderStyled = styled.div(({ theme }) => {
  return {
    width: `calc(100% - ${theme.space[2]}*2)`,
    background: theme.color.wfGrey300,
    position: 'absolute',
    transform: 'translateX(-50%)',
    left: '50%',
    height: 1,
    bottom: 0,
  };
});

export {
  ContentWrapperStyled,
  TitleWrapperStyled,
  DateWrapperStyled,
  InboxItemStyled,
  FileNameStyled,
  UserNameStyled,
  ContentStyled,
  BorderStyled,
  TypeStyled,
  DateStyled,
};
